import { createContext } from 'react'

const PusherContext = createContext({
  pusher: null,
  justReconnected: false,
  debug: false,
})

export default PusherContext
